import Box from "../../lib/appfuse-react/component/Box";
import Button from "../../lib/appfuse-react/component/Button";
import Typography from "@material-ui/core/Typography";
import usePrompt from "../../lib/appfuse-react/hook/usePrompt";
import lang from "../../lib/appfuse-react/core/lang";

function ButtonTest() {
    const prompt = usePrompt();

    const handleClick = event => {
        prompt.info(`You click the button:\n- value: ${event.value}`)
    }

    const handleConfirmedClick = event => {
        prompt.info(`You click the button:\n- value: ${event.value}\n- action: ${event.action}`)
    }

    const handleLongRunningClick = async event => {
        const result = await longRunningTask();
        prompt.info(`You click the button:\n- value: ${event.value}\n- resule: ${result}`)
    }

    const longRunningTask = async () => {
        const promise = new Promise((resolve) => {
            lang.delay(() => {
                resolve('done');
            }, 5*1000)
        })

        return promise;
    }



    return (
        <Box display="flex" flexDirection="column" padding={2} gap={2}>
            <Box display="flex" gap={2} flexWrap="wrap" >
                <Typography>Contained</Typography>
                <Button variant="contained" text="Click Me" value="save" onClick={handleClick} />
                <Button variant="contained" icon="save" text="Confirmation" confirmation="Are you sure?" value="save" onClick={handleConfirmedClick} />
                <Button variant="contained" icon="save" title="Long running task" value="save" onClick={handleLongRunningClick} >
                    <Typography>Long running task</Typography>
                </Button>
            </Box>
            <Box display="flex" gap={2} flexWrap="wrap" >
                <Typography>Outlined</Typography>
                <Button variant="outlined" text="Click Me" />
                <Button variant="outlined" icon="save" text="Click Me"  />
                <Button variant="outlined" icon="save" title="Button with children">
                    <Typography>Click Me</Typography>
                </Button>
            </Box>
            <Box display="flex" gap={2} flexWrap="wrap" >
                <Typography>Text</Typography>
                <Button variant="text" text="Text Only"  />
                <Button variant="text" icon="save" text="Text And Icon"  />
                <Button variant="text" icon="save" title="Button with children">
                    <Typography>Click Me</Typography>
                </Button>
            </Box>
            <Box display="flex" gap={2} flexWrap="wrap" >
                <Typography>Icon</Typography>
                <Button variant="icon" icon="save" text="Click Me"  />
                <Button variant="icon" icon="save" title="Icon Button with no text"/>
            </Box>
        </Box>
    )
}

export default ButtonTest;